export default __webpack_public_path__ + "static/media/referHost.53de891a.svg";